<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ $t('physicalAssessment') }}</h5>
                <p class="mb-0 text-sm">
                  {{ $t('assessmentListing') }}
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto d-flex gap-2">
                  <button
                    v-if="state.selectedAvaliacoes.length > 0"
                    type="button"
                    class="mb-0 btn bg-gradient-danger btn-sm"
                    @click="deletarSelecionados()"
                  >
                    <i class="fas fa-trash me-1"></i> Apagar Selecionados ({{ state.selectedAvaliacoes.length }})
                  </button>
                  <button
                    v-if="state.avaliacoes.length > 0"
                    type="button"
                    class="mb-0 btn bg-gradient-warning btn-sm"
                    @click="deletarTodos()"
                  >
                    <i class="fas fa-trash-alt me-1"></i> Apagar Todos
                  </button>
                  <button
                    type="button"
                    class="mb-0 btn bg-gradient-success btn-sm"
                    @click="formularioAvaliacao()"
                  >
                    +&nbsp; {{ $t('newAssessment') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="!studentOn">
              <span class="mt-5 text-center">
                <h5>{{ $t('selectStudentMessage') }}</h5>
              </span>
            </div>
            <div v-else>
              <div v-if="state.avaliacoes.length > 0" class="mb-3 d-flex align-items-center">
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  :checked="isAllSelected"
                  @change="toggleSelectAll"
                  style="cursor: pointer;"
                />
                <label class="form-check-label" style="cursor: pointer;" @click="toggleSelectAll">
                  Selecionar Todos
                </label>
              </div>
              <MyTable :data="state.avaliacoes" :columns="columns" :itemsPerPage="12">
                <template v-slot:row="{ row }">
                  <td colspan="4">
                    <table class="w-100">
                      <tbody>
                        <tr>
                          <td class="text-sm" style="width: 40px;">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              :checked="isSelected(row.id)"
                              @change="toggleSelection(row.id)"
                              style="cursor: pointer;"
                            />
                          </td>
                          <td class="text-sm w-30">
                            {{ row.assessment_location }}
                          </td>
                          <td class="text-sm text-center w-40">
                            {{ $filters.datePtbr(row.assessment_date) }}
                          </td>
                          <td class="text-sm">
                            <div class="float-end d-flex">
                              <div class="me-3">
                                <div class="m-1">
                                  <span
                                    class="pointer"
                                    :title="$t('editAssessment')"
                                    data-bs-placement="top"
                                    @click="formularioAvaliacao(row.id)"
                                  >
                                    <i class="fas fa-pen text-secondary me-2"></i>
                                    {{ $t('editAssessment') }}
                                  </span>
                                </div>
                              </div>
                              <div>
                                <div class="m-1">
                                  <span
                                    class="pointer"
                                    data-bs-toggle="tooltip"
                                    :title="$t('deleteAssessment')"
                                    data-bs-placement="top"
                                    v-tooltip
                                    @click="deletarAvaliacao(row)"
                                  >
                                    <i class="fas fa-trash text-secondary me-2"></i>
                                    {{ $t('delete') }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  <div class="mx-3 d-flex justify-content-between text-sm">
                    <div :class="row.hasAnamnese ? 'text-info' : 'text-danger'">
                      {{ $t('anamnesis') }}
                    </div>
                    <div :class="row.hasCircumference ? 'text-info' : 'text-danger'">
                      {{ $t('circumference') }}
                    </div>
                    <div :class="row.hasBodyComposition ? 'text-info' : 'text-danger'">
                      {{ $t('bodyComposition') }}
                    </div>
                    <div :class="row.hasPostural ? 'text-info' : 'text-danger'">
                      {{ $t('posturalAssessment') }}
                    </div>
                    <div :class="row.hasNeuromotor ? 'text-info' : 'text-danger'">
                      {{ $t('neuromotor') }}
                    </div>
                    <div :class="row.hasLoadTest ? 'text-info' : 'text-danger'">
                      {{ $t('loadTest') }}
                    </div>
                    <div :class="row.hasVoMax ? 'text-info' : 'text-danger'">
                      {{ $t('voMax') }}
                    </div>
                  </div>
                  <div class="text-sm mt-3">
                    <span class="mx-3" v-if="row['body_composition']"
                      ><span class="font-weight-bold">{{ $t('height') }}: </span>
                      {{ row['body_composition']['height'] }}m</span
                    >
                    <span class="mx-3" v-if="row['body_composition']"
                      ><span class="font-weight-bold">{{ $t('weight') }}: </span>
                      {{ row['body_composition']['weight'] }}kg</span
                    >
                    <span class="mx-3" v-if="row['body_composition']"
                      ><span class="font-weight-bold">{{ $t('fat') }}: </span>
                      {{ row['body_composition']['fat_percentage'] }}%</span
                    >
                    <span class="mx-3" v-if="row['body_composition']"
                      ><span class="font-weight-bold">{{ $t('leanWeight') }}: </span>
                      {{ row['body_composition']['skinny_weight'] }}%</span
                    >
                    <span class="mx-3" v-if="row['body_composition']"
                      ><span class="font-weight-bold">{{ $t('bmi') }}: </span>
                      {{ row['body_composition']['imc'] }}</span
                    >
                    <span class="mx-3"
                      ><span class="font-weight-bold">{{ $t('vo2') }}: </span>
                      {{ parseFloat(row['voMax']).toFixed(2) }}</span
                    >
                  </div>
                </td>
              </template>
            </MyTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import avaliacaoFisicaRepository from '../../../../services/api/avaliacaoFisicaRepository'
import MyTable from '../../../../components/MyTable.vue'
import { useRouter } from 'vue-router'
import moment from 'moment'

export default {
  components: {
    MyTable,
  },
  setup() {
    const router = useRouter()
    const swal = inject('$swal')
    const store = useStore()
    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      studentOn.value = store.getters.StudentManager
      if (studentOn.value) {
        listarAvaliacoes()
      }
    })

    //const hidePassword = ref(true)
    // const passwordFieldIcon = computed(() => hidePassword.value ? ['fa', 'eye'] : ['fa', 'eye-slash']);
    // const passwordFieldType = computed(() => hidePassword.value ? "password" : "text");

    let studentOn = ref(false)
    const { t } = useI18n()

    const columns = ref([
      {
        label: t('locationColumn'),
        field: 'assessment_location',
        sortable: '',
      },
      {
        label: t('testDateColumn'),
        field: 'assessment_date',
        sortable: '',
      },
      /*{
        label: t('heightColumn'),
        field: '',
        sortable: ''
      },
      {
        label: t('weightColumn'),
        field: '',
        sortable: ''
      },
      {
        label: t('fatColumn'),
        field: '',
        sortable: ''
      },
      {
        label: t('bmiColumn'),
        field: '',
        sortable: ''
      },*/
      {
        label: t('actionsColumn'),
        field: 'actions',
      },
    ])

    const state = reactive({
      avaliacoes: [],
      selectedAvaliacoes: [],
    })

    const listarAvaliacoes = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      avaliacaoFisicaRepository
        .AvaliacaoGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.log(response)
          state.avaliacoes = []
          if (response.data.success) {
            let training_plan_id = store.getters.TrainingPlanManager
            state.avaliacoes = response.data.data.filter((item) => {
              if (parseInt(item.training_plan_id) === training_plan_id) return item
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao listar avaliações!',
            text: error.message,
          })
        })
    }

    function formularioAvaliacao(id = 0) {
      parseInt(id) !== 0
        ? router.push(`/avaliacao-fisica/formulario/${id}`)
        : router.push('/avaliacao-fisica/formulario')
    }

    function deletarAvaliacao(item) {
      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar a avaliação?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarAvaliacaoConfirma(item.id)
        }
      })
    }

    function deletarAvaliacaoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      avaliacaoFisicaRepository
        .AvaliacaoDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: 'Removido!',
              text: 'Avaliação removida com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              listarAvaliacoes()
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar avaliação!',
            text: error.message,
          })
        })
    }

    // Funções de seleção
    function toggleSelection(id) {
      const index = state.selectedAvaliacoes.indexOf(id)
      if (index > -1) {
        state.selectedAvaliacoes.splice(index, 1)
      } else {
        state.selectedAvaliacoes.push(id)
      }
    }

    function toggleSelectAll() {
      if (isAllSelected.value) {
        state.selectedAvaliacoes = []
      } else {
        state.selectedAvaliacoes = state.avaliacoes.map(a => a.id)
      }
    }

    function isSelected(id) {
      return state.selectedAvaliacoes.includes(id)
    }

    const isAllSelected = computed(() => {
      return state.avaliacoes.length > 0 &&
             state.selectedAvaliacoes.length === state.avaliacoes.length
    })

    // Funções de exclusão em massa
    function deletarSelecionados() {
      if (state.selectedAvaliacoes.length === 0) {
        swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Nenhuma avaliação selecionada!',
        })
        return
      }

      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${state.selectedAvaliacoes.length} avaliação(ões) selecionada(s)?`,
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar!',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-danger',
          cancelButton: 'btn bg-gradient-secondary',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarMultiplasAvaliacoes(state.selectedAvaliacoes)
        }
      })
    }

    function deletarTodos() {
      if (state.avaliacoes.length === 0) {
        return
      }

      swal({
        title: 'ATENÇÃO!',
        text: `Deseja realmente deletar TODAS as ${state.avaliacoes.length} avaliações? Esta ação não pode ser desfeita!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar TODAS!',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-danger',
          cancelButton: 'btn bg-gradient-secondary',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const todosIds = state.avaliacoes.map(a => a.id)
          deletarMultiplasAvaliacoes(todosIds)
        }
      })
    }

    async function deletarMultiplasAvaliacoes(ids) {
      store.commit('SET_SPLASH_SCREEN', true)
      let deletedCount = 0
      let errorCount = 0

      for (const id of ids) {
        try {
          const response = await avaliacaoFisicaRepository.AvaliacaoDelete(id)
          if (response.data.success) {
            deletedCount++
          } else {
            errorCount++
          }
        } catch (error) {
          console.error(`Erro ao deletar avaliação ${id}:`, error)
          errorCount++
        }
      }

      store.commit('SET_SPLASH_SCREEN', false)

      if (errorCount === 0) {
        swal({
          title: 'Sucesso!',
          text: `${deletedCount} avaliação(ões) removida(s) com sucesso!`,
          icon: 'success',
          customClass: {
            confirmButton: 'btn bg-gradient-success',
          },
          buttonsStyling: false,
        }).then(() => {
          state.selectedAvaliacoes = []
          listarAvaliacoes()
        })
      } else {
        swal({
          title: 'Atenção',
          text: `${deletedCount} avaliação(ões) removida(s). ${errorCount} erro(s) encontrado(s).`,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn bg-gradient-warning',
          },
          buttonsStyling: false,
        }).then(() => {
          state.selectedAvaliacoes = []
          listarAvaliacoes()
        })
      }
    }

    return {
      studentOn,
      state,
      columns,
      deletarAvaliacao,
      formularioAvaliacao,
      toggleSelection,
      toggleSelectAll,
      isSelected,
      isAllSelected,
      deletarSelecionados,
      deletarTodos,
    }
  },
}
</script>
